import { getAssets } from "@unisearch/helpers";
import React from "react";
import styles from "./hero.module.scss";

export const AccommodationLandingHero = () => {
  return (
    <section className={styles.landing_hero}>
      <div className={styles.circle1}></div>
      <div className={styles.circle2}></div>
      <div className={`container ${styles.container}`}>
        <div className={styles.wrapper}>
          <div className={styles.content_wrapper}>
            {/* <h3>Tellus orci pellentesque fermentum tempus.</h3> */}
            <h1>
              <span className="color-orange">Accommodation</span> Through
              UniSeach
            </h1>
            <p>
              Looking for student accommodation for your next year at uni? We
              know having the right base is a big deal, and we're here to help
              you find the right accommodation that meets your budget.
            </p>
          </div>

          <div className={styles.featured_wrapper}>
            <img
              src={getAssets("assets/accommodation/landing/accommodation.png")}
              alt="accommodation"
            />

            <div className={styles.student_community}>
              <div className={styles.student_community_heading}>
                Our Satisfied Student Community
              </div>
              <div className={styles.student_community_text}>
                Over 100,000 active users
              </div>
              <img
                src={getAssets(
                  "assets/accommodation/landing/student-community.png"
                )}
                alt="student-community"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccommodationLandingHero;
